import { Toggle } from '@ori-ui/components';
import { styled } from '@ori-ui/mui';

export const Root = styled(Toggle)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  marginBottom: theme.spacing(4),
}));
